import React, { useContext } from 'react'
import AppContext from '../context'
import BasketItem from './BasketItem'
import { Button } from '@missionlabs/smartagent-app-components'
import useInterval from '../hooks/useInterval'
import { ClipLoader } from 'react-spinners'

interface Props {

}


const Basket: React.FC<Props> = () => {

    const { cart, startPayment, state, cartID, error, order, updateCart, isPaying, transferSuccessful } = useContext(AppContext);


    const canOrder = () => !!(
        // cart?.progress.hasBillingAddress &&
        cart?.progress.hasDeliveryAddress &&
        cart.progress.hasProducts &&
        cart.progress.hasDeliveryMethod
    )

    useInterval(() => {
        if (cartID) {
            updateCart(cartID)
        }
    }, 2000)

    return (
        <section className="basket">
            <header>
                <h2>Basket</h2>
            </header>

            {!!cart && (
                <div className="sm-pad">
                    <ul className="row column">
                        {cart.products.map(p => (
                            <BasketItem key={p.sku} {...p} />
                        ))}

                    </ul>

                    <aside className="sm-pad">
                        <p className="row between">
                            <span>Sub-total</span>
                            <span>{cart.totals.subTotal}</span>
                        </p>

                        <p className="row between">
                            <span>Standard delivery</span>
                            <span>{cart.totals.delivery}</span>
                        </p>

                        <p className="row between">
                            <span>Discounts and saving</span>
                            <span>{cart.totals.discount}</span>
                        </p>

                        <p className="row between font-attention xsm-mar-top">
                            <span>Total:</span>
                            <span>{cart.totals.total}</span>
                        </p>

                    </aside>

                    <footer className="basket-controls sm-pad row">
                        {transferSuccessful && !error && (<p className="font-success">Payment initiated successfully</p>)}

                        {state === "buying" && canOrder() && (
                            <>
                            {!!error && (<p className="error">{error}</p>)}
                            <div className="row end fixed-bottom">
                                <Button
                                    elastic
                                    round
                                    data-testid="transfer-pay-button"
                                    styling="primary"
                                    onClick={async () => await startPayment(cartID!)}
                                    disabled={isPaying}
                                >
                                    {!isPaying ? `Transfer & Pay` : <div data-testid="loading-spinner" style={{ display: "contents" }}><ClipLoader size={16} color='white' /></div>}
                                </Button>
                            </div>
                            </>
                        )}

                        {state === "finished" && (
                            <div className="sm-pad">
                                <h3>Order Number</h3>
                                <p id="order_no">#{order?.orderClientID ?? order?.orderID}</p>
                            </div>
                        )}
                    </footer>
                </div>
            )}

        </section>
    )
}

export default Basket
